import React from "react";
import {useQuery} from "@apollo/client";
import {getChartMeasurementsQuery} from "../measurements/MeasurementQueries";
import MeasurementsChart from "../measurements/MeasurementsChart";
import {Alert, Container} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import PageTitle from "../../../layout/PageTitle";
import {AddButton} from "../../../helpers/ButtonHelper";

const MeasurementsDashboard = () => {
  const { data } = useQuery(getChartMeasurementsQuery)

  return (
    <div className="page-container col">
      <PageTitle title='Grafic Masuratori' buttons={
        <AddButton to='/my_measurements/new' text='Adauga masuratori' />
        // <NavLink to='/my_measurements/new' className='link-primary fs-6 mx-3 float-end'>
        //   Adauga masuratori
        // </NavLink>
      } />
      {data && data.measurements.length ?
        <Container className="bg-white p-4 border rounded shadow">
          <MeasurementsChart data={data.measurements} />
        </Container>
        :
        <Alert variant='warning'>
          Nu ai nici o valoare adaugata
          <NavLink to='/my_measurements/new' className='mx-3'>Adauga acum</NavLink>
        </Alert>
      }
    </div>
  )
};

export default MeasurementsDashboard;
